const getUserInitials = (firstName, lastaName) => {
  if (!lastaName) {
    [firstName, lastaName] = firstName.split(' ');
  }

  return (firstName.charAt(0) + lastaName.charAt(0)).toUpperCase();
};

export default getUserInitials;
